<div class="space-y-4 list-container">
  <h1 class="text-2xl font-bold">Produtos com Tags</h1>

  @if (error()) {
    <app-alert [type]="'danger'">{{ error() }}</app-alert>
  }

  <form (ngSubmit)="onFormSubmit()" class="flex flex-col gap-3 md:flex-row md:items-end md:flex-wrap">
    <div class="w-52">
      <label class="block text-sm font-medium mb-1">Tipo de busca</label>
      <select
        [ngModel]="searchType()"
        (ngModelChange)="searchType.set($event)"
        name="searchType"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      >
        <option [ngValue]="'RefId'">RefId (string)</option>
        <option [ngValue]="'ProductName'">Nome do produto (string)</option>
        <option [ngValue]="'ProductId'">ID do produto (number)</option>
        <option [ngValue]="'SkuId'">ID do SKU (number)</option>
      </select>
    </div>

    <div class="flex-1 min-w-[180px]">
      <label class="block text-sm font-medium mb-1">Valor</label>
      <input
        type="text"
        [ngModel]="searchValue()"
        (ngModelChange)="searchValue.set($event)"
        name="searchValue"
        [placeholder]="
          searchType() === 'ProductId'
            ? 'Informe o ProductId'
            : searchType() === 'SkuId'
              ? 'Informe o SkuId'
              : searchType() === 'RefId'
                ? 'Informe o RefId'
                : 'Informe o ProductName'
        "
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      />
    </div>

    <div class="w-44">
      <label class="block text-sm font-medium mb-1">Tipo de tag</label>
      <select
        [ngModel]="tagTypeId()"
        (ngModelChange)="tagTypeId.set($event)"
        name="tagTypeId"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      >
        <option [ngValue]="null">Todos</option>
        @for (t of tagTypes(); track t.id) {
          <option [ngValue]="t.id">{{ t.name }}</option>
        }
      </select>
    </div>

    <div class="w-32">
      <label class="block text-sm font-medium mb-1">Ordenação</label>
      <select
        [ngModel]="order()"
        (ngModelChange)="order.set($event)"
        name="order"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      >
        <option [ngValue]="'DESC'">DESC</option>
        <option [ngValue]="'ASC'">ASC</option>
      </select>
    </div>

    <div class="w-28">
      <label class="block text-sm font-medium mb-1">Tamanho</label>
      <input
        type="number"
        min="1"
        [ngModel]="size()"
        (ngModelChange)="size.set($event)"
        name="size"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
      />
    </div>

    <div class="md:ml-2">
      <app-button type="submit" color="primary">Buscar</app-button>
    </div>
  </form>

  @if (loading()) {
    <div class="my-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!loading()) {
    <div class="overflow-x-auto mt-2">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead class="bg-neutral-100 dark:bg-neutral-700">
          <tr>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">SkuId</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">RefId</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Imagem</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Nome</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Tipo de tag</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Preço</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Última impressão</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Última atualização</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (p of data(); track p.skuId + '_' + p.tagTypeId; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.skuId }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.refId }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                @if (p.imageUrl) {
                  <img
                    [ngSrc]="p.imageUrl"
                    width="48"
                    height="48"
                    alt=""
                    class="w-12 h-12 object-cover rounded"
                  />
                }
              </td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.name }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.tagTypeName }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.price | currency:'BRL':'symbol' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.lastPrint ?? '-' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ p.lastUpdate ?? '-' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <app-button color="primary" size="small" icon="eye" app-tool-tip tooltip-text="Visualizar"></app-button>
                <app-button color="secondary" size="small" icon="printer" app-tool-tip tooltip-text="Imprimir"></app-button>
              </td>
            </tr>
          } @empty {
            <tr class="bg-neutral-50 dark:bg-neutral-800">
              <td colspan="9" class="p-3 text-sm text-center">Nenhum resultado. Faça uma busca.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (paginationState().totalItems > 0) {
      <app-pagination
        [paginationState]="paginationState()"
        [onPaginationChange]="onPageChange"
        [visiblePages]="5"
        displayMode="full"
      />
    }
  }
</div>
